/* Alaya - Frequently Bought Together */
(function () {
  if (window.__alayaFbt) { window.__alayaFbt.init(); return; }

  var OPEN = '\u007B\u007B';
  var CLOSE = '\u007D\u007D';

  function group(cents, precision, thousand, decimal) {
    var num = (cents / 100).toFixed(precision);
    var parts = num.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
    return parts[1] ? int + decimal + parts[1] : int;
  }

  function formatMoney(cents, format) {
    cents = parseInt(cents || 0, 10) || 0;
    format = (format || '').replace(/<[^>]*>/g, '');
    var value;
    if (format.indexOf('amount_no_decimals_with_comma_separator') > -1) {
      value = group(cents, 0, '.', ',');
    } else if (format.indexOf('amount_with_comma_separator') > -1) {
      value = group(cents, 2, '.', ',');
    } else if (format.indexOf('amount_no_decimals_with_space_separator') > -1) {
      value = group(cents, 0, ' ', ',');
    } else if (format.indexOf('amount_with_space_separator') > -1) {
      value = group(cents, 2, ' ', ',');
    } else if (format.indexOf('amount_no_decimals') > -1) {
      value = group(cents, 0, ',', '.');
    } else {
      value = group(cents, 2, ',', '.');
    }
    var s = format.indexOf(OPEN);
    var e = format.indexOf(CLOSE);
    if (s === -1 || e === -1) { return value; }
    return (format.slice(0, s) + value + format.slice(e + 2)).trim();
  }

  function cfgOf(root) { return root.__fbtCfg || {}; }

  function variantEl(row) { return row.querySelector('[data-fbt-variant]'); }

  function rowPrice(row) {
    var ve = variantEl(row);
    if (ve && ve.tagName === 'SELECT' && ve.selectedIndex > -1) {
      var opt = ve.options[ve.selectedIndex];
      var p = opt && opt.getAttribute('data-price');
      if (p !== null && p !== undefined && p !== '') { return parseInt(p, 10) || 0; }
    }
    var priceEl = row.querySelector('[data-fbt-price]');
    return priceEl ? parseInt(priceEl.getAttribute('data-price') || 0, 10) || 0 : 0;
  }

  function paintRowPrice(row, format) {
    var priceEl = row.querySelector('[data-fbt-price]');
    if (!priceEl) { return; }
    var cents = rowPrice(row);
    priceEl.setAttribute('data-price', cents);
    priceEl.textContent = formatMoney(cents, format);
  }

  function refresh(root) {
    var cfg = cfgOf(root);
    var rows = root.querySelectorAll('[data-fbt-item]');
    var total = 0;
    var count = 0;
    Array.prototype.forEach.call(rows, function (row) {
      var check = row.querySelector('[data-fbt-check]');
      if (check && check.checked) { total += rowPrice(row); count += 1; }
    });
    var totalEl = root.querySelector('[data-fbt-total]');
    if (totalEl) { totalEl.textContent = formatMoney(total, cfg.moneyFormat); }
    var btn = root.querySelector('[data-fbt-add]');
    if (btn && !btn.__busy) {
      btn.disabled = count === 0;
      btn.textContent = count > 1 ? 'Add ' + count + ' items to cart' : 'Add selected to cart';
    }
  }

  function message(root, text, isError) {
    var el = root.querySelector('[data-fbt-msg]');
    if (!el) { return; }
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = text;
    el.className = 'alaya-fbt__msg' + (isError ? ' alaya-fbt__msg--error' : '');
    el.hidden = false;
  }

  function addToCart(root) {
    var cfg = cfgOf(root);
    var btn = root.querySelector('[data-fbt-add]');
    var items = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-fbt-item]'), function (row) {
      var check = row.querySelector('[data-fbt-check]');
      var ve = variantEl(row);
      if (check && check.checked && ve && ve.value) {
        items.push({ id: parseInt(ve.value, 10), quantity: 1 });
      }
    });
    if (!items.length) { return; }
    message(root, '');
    if (btn) { btn.__busy = true; btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch((cfg.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (r.ok) { return r.json(); }
        return r.json().then(function (d) {
          throw new Error((d && (d.description || d.message)) || 'Could not add to cart.');
        });
      })
      .then(function () {
        message(root, items.length > 1 ? items.length + ' items added to your cart.' : 'Added to your cart.');
        try {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {}
      })
      .catch(function (err) {
        message(root, (err && err.message) || 'Something went wrong. Please try again.', true);
      })
      .then(function () {
        if (btn) { btn.__busy = false; }
        refresh(root);
      });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-alaya-fbt]'), function (root) {
      if (root.__fbtInit) { return; }
      root.__fbtInit = true;
      var cfgEl = root.querySelector('[data-fbt-config]');
      var cfg = {};
      if (cfgEl) {
        try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
      }
      root.__fbtCfg = cfg;
      refresh(root);
    });
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) { return; }
    var root = target.closest('[data-alaya-fbt]');
    if (!root) { return; }
    var row = target.closest('[data-fbt-item]');
    if (row && target.matches('[data-fbt-variant]')) {
      paintRowPrice(row, cfgOf(root).moneyFormat);
    }
    refresh(root);
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) { return; }
    var btn = target.closest('[data-fbt-add]');
    if (!btn) { return; }
    e.preventDefault();
    var root = btn.closest('[data-alaya-fbt]');
    if (root) { addToCart(root); }
  });

  document.addEventListener('variant:change', init, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);

  window.__alayaFbt = { init: init };
  init();
})();
